import React from 'react';
import { AppProvider, useApp } from './Context';

import ChartFilters from './ChartFilters';
import ChartDisplay from './ChartDisplay';
import DataDownload from './DataDownload';
import ErrorMessage from '../components/ErrorMessage';

function AppContent() {
    const { error } = useApp();

    if (error) {
        return <ErrorMessage message={error} />;
    }

    return (
        <>
            <DataDownload />
            <ChartDisplay />
            <ChartFilters />
        </>
    );
}

function App() {
    return (
        <AppProvider>
            <AppContent />
        </AppProvider>
    );
}

export default App;
